export default ['gms', 'tugo', 'tugoStudent', 'destination']